import httpClient from "@plugins/http";
import { ApiResponse } from "@apis/api.ts";

const saveLessonEditHistory = async (lessonUuid, assignmentUuid?): Promise<ApiResponse<object>> => {
  const params = new URLSearchParams();
  if (assignmentUuid) {
    params.append("assignmentUuid", assignmentUuid);
  }

  return await httpClient.post(`/apis/lesson/edit-history/save/${lessonUuid}?${params}`);
};

const getUserLessonEditHistory = async (): Promise<ApiResponse<object[]>> => {
  return await httpClient.get(`/apis/lesson/edit-history/user/list`);
};

export default {
  saveLessonEditHistory,
  getUserLessonEditHistory,
};
